class ProductStickyBar extends HTMLElement {
  connectedCallback() {
    this.initStickyAddSelect();
    this.initSticky();
    this.initDropdown();
  }

  initSticky() {
    const stickyEl = document.querySelector('.product-sticky-add');
    const addToCartBtn = document.querySelector('[name="add"]');

    if (!stickyEl || !addToCartBtn) return;

    let isSticky = false;

    const getButtonBottom = () => {
      const rect = addToCartBtn.getBoundingClientRect();
      return rect.bottom + window.scrollY;
    };

    let buttonBottom = getButtonBottom();

    window.addEventListener('resize', () => {
      buttonBottom = getButtonBottom();
    });

    window.addEventListener(
      'scroll',
      () => {
        const scrollTop = window.scrollY;

        if (scrollTop > buttonBottom && !isSticky) {
          stickyEl.classList.add('is-sticky');
          isSticky = true;
        }

        if (scrollTop <= buttonBottom && isSticky) {
          stickyEl.classList.remove('is-sticky');
          isSticky = false;
        }
      },
      { passive: true }
    );
  }

  initStickyAddSelect() {
    this.select = this.querySelector('.variant-option--dropdowns:not(.hidden) select');
    this.actionWrapper = this.querySelector('.product-sticky-add__wapper');

    if (!this.select || !this.actionWrapper) return;

    const updateState = () => {
      const value = this.select?.value;
      if (value) {
        this.actionWrapper?.classList.add('allow_add');
        const variantPicker = document.querySelector(".product-details .variant-picker");
        if (variantPicker) {
          const variantSize = variantPicker.querySelector(`input[value="${value}"]`);
          if (variantSize) {
            variantSize.click();
          }
        }
      } else {
        this.actionWrapper?.classList.remove('allow_add');
      }
    };
    this.select.addEventListener('change', updateState);
  }

  initDropdown() {
    const dropdowns = this.querySelectorAll('.js-sticky-dropdown-container');
    dropdowns.forEach(dropdown => {
      const toggle = dropdown.querySelector('.js-sticky-dropdown-toggle');
      toggle.addEventListener('click', function(e) {
        e.stopPropagation();
        dropdowns.forEach(other => {
          if (other !== dropdown) other.classList.remove('is-open');
        });
        dropdown.classList.toggle('is-open');
      });
    });
    document.addEventListener('click', (e) => {
        dropdowns.forEach(dropdown => {
            if (!dropdown.contains(e.target)) {
                dropdown.classList.remove('is-open');
            }
        });
    });
  }

  updateSticky = (event) => {
    // const newSticky = event.detail.data.html.querySelector('sticky-addtocart .product-sticky-add__flex');
    // const currentSticky = this.querySelector(".product-sticky-add__flex");

    // if (!newSticky || !currentSticky) return;

    // if (currentSticky.innerHTML !== newSticky.innerHTML) {
    //   currentSticky.replaceWith(newSticky);
    //   this.initStickyAddSelect();
    // }
  }
}

if (!customElements.get('sticky-addtocart')) {
  customElements.define('sticky-addtocart', ProductStickyBar);
}